import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const EmployeeCategoryForm=React.lazy(() => import('./Form'));
const EmployeeCategoryTable=React.lazy(() => import('./Table'));
export const EmployeeCategory = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/employee-category/create',
    element: <EmployeeCategoryForm />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/employee-category/table',
    element: <EmployeeCategoryTable />,
  },

];
